import { render } from "./ShopEditDialog.vue?vue&type=template&id=26fec81c&scoped=true"
import script from "./ShopEditDialog.vue?vue&type=script&lang=js"
export * from "./ShopEditDialog.vue?vue&type=script&lang=js"

import "./ShopEditDialog.vue?vue&type=style&index=0&id=26fec81c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-26fec81c"]])

export default __exports__